<div class="col-sm-12 col-md-8">
    <div class="govuk-grid-row">
        <div class="govuk-grid-column-one-half">
            <form [formGroup]="facilityForm" *ngIf="showFa">

                <div class="govuk-form-group">
                    <label class="govuk-label govuk-fieldset__legend--m" for="change_venue">
                        Change venue
                    </label>
                    <select (change)="onChangeFacility()" formControlName="selectedFacility" class="govuk-select"
                        id="change_venue" name="change_venue">
                        <option *ngIf="!showCalendar" value=""></option>
                        <option *ngFor="let option of facilities" [value]="option.id">
                            {{option.name}}
                        </option>
                    </select>
                </div>

            </form>
        </div>
    </div>
</div>

<ng-container *ngIf="!noMoreDates">
  <div class="col-sm-12 col-md-8 mt-3 p-0">
    <div>
        <span *ngIf="adminJourney">
            <label style="font-size: 19px;">
                <input style="width: 19px; height: 19px; margin: 10px;" type="checkbox"
                    [ngModel]="adminToggleDateRestrictions" (change)="reRun(true)">
                Override availability</label>
        </span>
    </div>
    <div class="calendar" *ngIf="availableDays && showCalendar">
        <div class="inner-div">
            <!-- <mat-calendar #calendar [selected]="selectedDate" [minDate]="minDate" [maxDate]="maxDate"
                (selectedChange)="updateSlots($event)" [dateFilter]="unavailableDates">
            </mat-calendar> -->

            <mat-calendar #calendar [selected]="selectedDate" [startAt]="startDate" [minDate]="minDate"
                [maxDate]="maxDate" (selectedChange)="newUpdateSlots($event)" [dateFilter]="unavailableDates"
                [headerComponent]="customHeader">
            </mat-calendar>


            <div class="availability-markers">
                <span class="available"></span><span class="mr-4">{{ 'CALENDAR.KEY_AVAILABLE' | translate }}</span>
                <span class="unavailable"></span><span>{{ 'CALENDAR.KEY_UNAVAILABLE' | translate }}</span>
            </div>
        </div>
    </div>
  </div>

  <fieldset class="col-sm-12 col-md-4 mt-3 time-slots" *ngIf="availableDays && showCalendar">
      <legend class="govuk-visually-hidden">Available time slots for {{ selectedDate | date }}</legend>
      <div class="row">
          <div class="text-center col-sm-12">
              <h2>
                  {{selectedDate | date : 'EEEE d MMMM': '' : translateService.currentLang}}</h2>
              <span *ngIf="slots?.length === 0" tabindex="0">{{ 'CALENDAR.NO_SLOTS_WARNING' | translate }}</span>
          </div>
      </div>
      <div class="row" [ngClass]="{'govuk-form-group--error': !selectedSlot && slotSelectionError}">
          <p *ngIf="!selectedSlot && slotSelectionError" id="time-selection-error" class="govuk-error-message">
              Please select a time slot to continue
          </p>
          <div *ngFor="let slot of slots" class="col-4 col-sm-4 col-md-6">
              <button class="slot-btn" (click)="selectSlot(slot)"
                  [ngClass]="{'selected-slot-btn': selectedSlot?.start === slot?.start}"
                  [attr.aria-pressed]="selectedSlot?.start === slot?.start">{{slot?.displayTime }}
              </button>
          </div>
      </div>
  </fieldset>
</ng-container>